var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallingOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.01729,17.33348,16.25163,15.567a2.03677,2.03677,0,0,0-2.88245.00006l-.34733.34769A39.2419,39.2419,0,0,1,8.14639,11.0348l.34751-.34788a2.04391,2.04391,0,0,0,0-2.88571L6.72812,6.03458a2.0382,2.0382,0,0,0-2.88245.00007L2.87713,7.004a2.87111,2.87111,0,0,0-.362,3.61481A39.06831,39.06831,0,0,0,13.43741,21.55133a2.86648,2.86648,0,0,0,3.61086-.36351l.9689-.969A2.04137,2.04137,0,0,0,18.01729,17.33348Zm-.52932,2.355-.96939.96948a2.11831,2.11831,0,0,1-2.66823.26807A38.31936,38.31936,0,0,1,3.1397,10.20538a2.12107,2.12107,0,0,1,.26694-2.67133l.96854-.96941a1.2899,1.2899,0,0,1,1.82349,0L7.96433,8.33108a1.29382,1.29382,0,0,1-.00018,1.82609l-.58813.58874a.375.375,0,0,0-.02493.50242,39.84534,39.84534,0,0,0,5.45727,5.46239.37416.37416,0,0,0,.50208-.02483l.58825-.5888a1.28836,1.28836,0,0,1,1.82349,0l1.76566,1.76644A1.29133,1.29133,0,0,1,17.488,19.68853Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.861,9.61428a2.598,2.598,0,0,1,2.59739,2.59981.38321.38321,0,1,0,.76641,0,3.36479,3.36479,0,0,0-3.3638-3.367.38357.38357,0,0,0,0,.76714Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.861,5.43764a.38357.38357,0,0,0,0,.76714,6.00609,6.00609,0,0,1,6.00369,6.00931.38324.38324,0,1,0,.76647,0A6.7729,6.7729,0,0,0,11.861,5.43764Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.861,2.02808a.38357.38357,0,0,0,0,.76714,9.41363,9.41363,0,0,1,9.41,9.41887.38321.38321,0,1,0,.76642,0A10.18043,10.18043,0,0,0,11.861,2.02808Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingOutline);
export default __webpack_public_path__ + "static/media/calling_outline.3db010c29c342e23c7347b5f600ce48a.svg";
export { ForwardRef as ReactComponent };